/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

const STRENGTH = {
    0: { name: '', color: 'white', progress: 0 },
    1: { name: 'Weak', color: 'danger', progress: 25 },
    2: { name: 'Weak', color: 'danger', progress: 25 },
    3: { name: 'Fair', color: 'warning', progress: 50 },
    4: { name: 'Good', color: 'info', progress: 75 },
    5: { name: 'Strong', color: 'success', progress: 100 }
};

export default STRENGTH;